/**
 * WebSocket Context Provider
 * Provides WebSocket connection to entire application
 */

import React, {
  createContext,
  useContext,
  useEffect as _useEffect
} from 'react'
import { useWebSocketWithConfig } from '../hooks/useWebSocketWithConfig'

const WebSocketContext = createContext(null)

export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext)
  if (!context) {
    throw new Error('useWebSocketContext must be used within WebSocketProvider')
  }
  return context
}

export const WebSocketProvider = ({ children, userId }) => {
  const ws = useWebSocketWithConfig(userId)

  return (
    <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>
  )
}
